//
// ─── IMPORTING NECESSARY ELEMENTS ───────────────────────────────────────
//
import { React, useEffect, useRef, useState } from 'react'
import { Html5Qrcode } from "html5-qrcode"

//
// ─── IMPORTING UTILS ───────────────────────────────────────
//
import Api from '../../../../contexts/Api'
import Button from '../../../Button'

// BEEP SOUND
import sound from '../../../../assets/music/nice-beep.mp3'
// SCSS
import './ModalScanStore.scss'

//
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const ModalScanStore = ({ open, onSuccess, onClose }) => {

  //
  // ─── STATE DECLARATION ───────────────────────────────────────
  //
  const [error, setError] = useState('')
  const [pending, setPending] = useState(false)
  const [scanning, setScanning] = useState(true)
  // Incrémenté à chaque tentative : `scanning` seul ne suffit pas à relancer
  // l'effet quand la caméra a échoué (il vaut déjà true, React ne rejoue rien).
  const [attempt, setAttempt] = useState(0)

  const scannerRef = useRef(null)
  const lastTextRef = useRef('')

  //
  // ─── CAMERA ───────────────────────────────────────
  //
  useEffect(() => {
    if (!scanning) return

    const scanner = new Html5Qrcode("store-reader")
    scannerRef.current = scanner
    const config = { fps: 10, qrbox: { width: 250, height: 250 }, rememberLastUsedCamera: true }

    scanner
      .start({ facingMode: "environment" }, config, handleDecoded)
      .catch(() => setError("L'accès à la caméra est nécessaire pour scanner."))

    return () => {
      if (scanner.getState && scanner.getState() === 2) scanner.stop().catch(() => { })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scanning, attempt])

  // BEEP SOUND
  const playBeep = () => { new Audio(sound).play() }

  //
  // ─── ENVOI DU PAYLOAD A L'API ───────────────────────────────────────
  //
  const handleDecoded = async (decodedText) => {
    if (lastTextRef.current === decodedText || pending) return
    lastTextRef.current = decodedText

    playBeep()
    setPending(true)
    if (scannerRef.current) await scannerRef.current.stop().catch(() => { })
    setScanning(false)

    const scan = await Api({
      endpoint: '/analytics/scan',
      data: { payload: decodedText },
      method: 'POST',
    })

    setPending(false)

    if (scan && scan.success) {
      onSuccess(scan.data)
    } else {
      setError((scan && scan.message) || 'Une erreur est survenue, réessayez.')
    }
  }

  //
  // ─── NOUVELLE TENTATIVE ───────────────────────────────────────
  //
  const retry = () => {
    lastTextRef.current = ''
    setError('')
    setScanning(true)
    setAttempt((value) => value + 1)
  }

  //
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return <div className={`modal-container two ${open ? '' : 'out'}`}>
    <div className="modal-background">
      <div className="modalScanStore">
        <p className='scanHelp'>Scannez le QR code affiché en caisse</p>
        <div id="store-reader"></div>
        {pending && <p className='scanPending'>Vérification…</p>}
        {error && <>
          <p className='scanError'>{error}</p>
          <Button className="button fourth" text='Réessayer' onClick={retry} />
        </>}
        <Button className="button secondary" text='Fermer' onClick={onClose} />
      </div>
    </div>
  </div>
}

export default ModalScanStore;
